import { styled } from "styled-components";

export const MainContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 32px;
    align-self: stretch;
`;

export const CardContainer = styled.div`
    display: flex;
    padding: 16px;
    align-items: flex-start;
    gap: 16px;
    align-self: stretch;
    border-radius: 16px;
    border: 1px solid ${({ theme }) => theme?.colors?.theme?.success};
    background: linear-gradient(
        270deg,
        rgba(103, 237, 65, 0.10) 0%,
        rgba(103, 237, 65, 0.00) 100%
    ), ${({ theme }) => theme?.colors?.theme?.contentBg};
    box-shadow: -4px 4px 0px 0px ${({ theme }) => theme?.colors?.theme?.success};
`;

export const IconWrapper = styled.div`
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    
    img {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }
`;

export const ContentWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    flex: 1 0 0;
`;

export const Title = styled.h3`
    align-self: stretch;
    color: ${({ theme }) => theme?.colors?.theme?.success};
    font-feature-settings: 'liga' off, 'clig' off;
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: 120%;
`;

export const Description = styled.p`
    align-self: stretch;
    color: ${({ theme }) => theme?.colors?.text?.headings};
    font-feature-settings: 'liga' off, 'clig' off;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
`;

export const CustomTPremiaCard = styled.div`
    border-radius: 16px;
    border: 1px solid ${({ theme }) => theme?.colors?.theme?.success};
    background: linear-gradient(
        270deg, 
        rgba(103, 237, 65, 0.10) 0%, 
        rgba(103, 237, 65, 0.00) 100%
    ), ${({ theme }) => theme?.colors?.theme?.contentBg};
    box-shadow: -4px 4px 0px 0px ${({ theme }) => theme?.colors?.theme?.success};
`;